import React, { useState } from 'react';
import '../scss/components/section.scss';
import Header from '.././components/header/header.jsx';
import PageTitle from '../components/page-title/page-title-v1';
import Blog from '../components/blog/blog-v1';
import dataBlog from '../assets/fake-data/data-blog';
import Brand from '../components/brand/brand-v1';
import dataBrand from '../assets/fake-data/data-brand';
import Flathelp from '../components/flat-help';
import Footer from '../components/footer/footer-v1';
import dataFooter from '../assets/fake-data/data-footer';
import Bottom from '../components/bottom';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import { Link } from 'react-router-dom';
import ReactPlayer from 'react-player/youtube'

function Popup(props) {
    return (props.trigger) ? (
        <div className="popup-video">
            <div className="overlay" onClick={() => props.setTrigger(false)}></div>
            <div className='popup-inner'>
                <div className="popup-inner-content">
                    <div className="mfp-iframe-scaler">
                        <ReactPlayer url='https://www.youtube.com/watch?v=i7EMACWuErA'
                            playing={false}
                            controls={false} className="popup-youtube">
                            <span className="icon-play"></span>
                        </ReactPlayer>
                        <button className='close-btn' onClick={() => props.setTrigger(false)}><i className="far fa-times"></i></button>
                        {props.children}
                    </div>

                </div>
            </div>
        </div>
    ) : "";
}


function AboutHome(props) {
    const [dataTab] = useState(
        [
            {
                id: 1,
                title: "Lack of Real-time Audience Insights",
            },
            {
                id: 2,
                title: "Lack of Personalized Communication at Scale",
            },
            {
                id: 3,
                title: "Lack of Proactive Crisis Management Tools",
            },
            {
                id: 4,
                title: "Lack of Comprehensive Data Integration",
            },
        ]
    )
    const [buttonPopup, setButtonPopup] = useState(false);
    return (
        <div className='wrapper-style' id='wrapper'>

            <div className="tf-section flat-about">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6 col-md-7">
                            <div className="post">
                                <h2 className="title-about text-t">Core Technology</h2>
                                <p className="text-1">
                                    The core of NextGenPR's innovation lies in the creation and continuous updating of digital twins—virtual personas representing both individual audience members and segments. These digital twins provide a dynamic, data-driven understanding of the audience, allowing PR teams to simulate and analyze audience behavior, preferences, and responses in real-time. This technology offers deep insights and detailed statistical reports, enabling more informed and strategic decision-making.
                                </p>
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-5">
                            <div className="wrap-img">
                                <div className="media">
                                    <img src={require('../assets/images/box-item/about-1.jpg')} alt="Nufti" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="flat-counter tf-counter">
                <div className="container">
                    <div className="row row-counter">
                        <div className="col-lg-7 col-md-12">
                            <div className="wrap">
                                <h2 className="text-t" style={{fontSize:"4em"}}>10+ Businesses
                                    use <span className="text-color-3" style={{fontSize:"1em"}}>Our Services.</span>
                                    </h2>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                            <div className="counter-box box-1">
                                <div className="content wow fadeInUp">
                                    <div className="number number-one" style={{fontSize:"3em"}}>100+</div>
                                    <p className="heading" style={{ fontSize: '3.5em' }}>PR Reports</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-2 col-md-6">
                            <div className="counter-box box-2">
                                <div className="content wow fadeInUp">
                                    <div className="number number-two" style={{fontSize:"3em"}}>1K+</div>
                                    <p className="heading" style={{ fontSize: '3.5em' }}>Personalized Messages</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="flat-about2">
                <div className="container">
                    <h2 className="text-t">The World Without Us!
                    </h2>
                    <div className="row" style={{ paddingTop: '3em' }}>
                        <div className="col-lg-12 col-md-12">
                            <Tabs>
                                <TabList className="menu-tab tab-title">
                                    {
                                        dataTab.map(data => (
                                            <Tab key={data.id} selectedClassName="selected-tab">
                                                <h3 className="inner" >{data.title}</h3>
                                            </Tab>
                                        ))
                                    }
                                </TabList>
                                <TabPanel>
                                    <div className="provenance">
                                        <p>In the current PR landscape, many professionals lack access to real-time, detailed insights into their audience's behavior and preferences. Traditional tools often provide static data that quickly becomes outdated, limiting the ability to make informed, timely decisions. NextGenPR fills this gap by offering dynamic digital twin technology that continuously updates with new data, providing real-time insights and allowing for more accurate audience modeling.
                                        </p>
                                    </div>
                                </TabPanel>
                                <TabPanel>
                                    <div className="provenance">
                                        <p>Personalized communication is crucial for effective PR, yet many existing solutions struggle to deliver highly customized content at scale. Generic messaging fails to engage diverse audience segments, leading to lower engagement and impact. NextGenPR addresses this gap by integrating with advanced generative AI like ChatGPT, enabling the creation of tailored content that resonates with individual audience members and segments across various channels.
                                        </p>
                                    </div>
                                    <img></img>
                                </TabPanel>
                                <TabPanel>
                                    <div className="provenance">
                                        <p>
                                            PR teams often lack proactive tools for early detection and management of potential crises. Current systems may only react to crises once they have escalated, resulting in significant reputational damage. NextGenPR’s digital twins are designed to monitor audience sentiment and behavior patterns in real-time, offering early warnings and strategic suggestions to mitigate crises before they escalate.
                                        </p>
                                    </div>
                                </TabPanel>
                                <TabPanel>
                                    <div className="provenance">
                                        <p>
                                            Many PR solutions fail to integrate data from diverse sources such as CRM systems, social media platforms, and marketing databases. This fragmented data approach leads to incomplete audience profiles and suboptimal PR strategies. NextGenPR overcomes this challenge by aggregating data from multiple sources to create comprehensive and dynamic virtual personas, providing a holistic view of the audience for more effective PR planning and execution.
                                        </p>
                                    </div>
                                </TabPanel>
                            </Tabs>
                        </div>
                    </div>
                </div>
            </div>


        </div>
    );
}

export default AboutHome;